import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import he from './locales/he.json';
import es from './locales/es.json';

export const LOCALES = [
  { code: 'fr', label: 'Francais', nativeLabel: 'Francais', dir: 'ltr', flag: 'FR' },
  { code: 'en', label: 'English', nativeLabel: 'English', dir: 'ltr', flag: 'EN' },
  { code: 'he', label: 'Hebrew', nativeLabel: 'Hebrew', dir: 'rtl', flag: 'IL' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Espanol', dir: 'ltr', flag: 'ES' },
];

export const DEFAULT_LOCALE = 'fr';

export const dirFor = (code) => LOCALES.find((l) => l.code === code)?.dir ?? 'ltr';

/** Keeps <html lang/dir> in sync so RTL (Hebrew) lays out correctly. */
export const applyDocumentLocale = (code) => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = code;
  document.documentElement.dir = dirFor(code);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      he: { translation: he },
      es: { translation: es },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'crm.locale',
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', applyDocumentLocale);
applyDocumentLocale(i18n.resolvedLanguage ?? DEFAULT_LOCALE);

export default i18n;
